// Shared by the public pages and their production HTML output.
export const PUBLIC_PAGE_SEO = {
  home: {
    path: '/',
    title: '24/7 Urgent Care & Hotel Doctor in Vietnam | VietClinics',
    description: 'Need a doctor in Vietnam? VietClinics coordinates 24/7 urgent care and doctor visits to hotels, apartments and Airbnb stays, with English-language support.',
    h1: 'Healthcare coordination in Vietnam',
    intro: 'VietClinics is an independent coordination service for international patients, expats and travellers. Providers review enquiries and confirm clinical suitability, availability and pricing before appointments are arranged.',
  },
  howItWorks: {
    path: '/how-it-works',
    title: 'How VietClinics Works | Enquiries & Care Coordination',
    description: 'Learn how VietClinics reviews care enquiries, requests provider options and helps coordinate next steps. Providers confirm suitability, availability and pricing.',
    h1: 'How VietClinics Works',
    intro: 'Share your needs and location. VietClinics reviews your enquiry, selected licensed providers review the request and confirm options, and we help coordinate your chosen next steps. Response and appointment times depend on the enquiry and provider availability.',
  },
  contact: {
    path: '/contact',
    title: 'Contact VietClinics | Phone, WhatsApp & Email Support',
    description: 'Contact VietClinics by phone, WhatsApp or email for non-emergency healthcare enquiries, appointment coordination and patient support in Vietnam.',
    h1: 'Contact & Support',
    intro: 'Contact VietClinics for non-emergency healthcare coordination in Vietnam. Use the contact form, phone, WhatsApp or email to share your enquiry.',
  },
  commonIllnesses: {
    path: '/common-illnesses-vietnam',
    title: 'Common Illnesses in Vietnam | Traveller Health Guide | VietClinics',
    description: 'A plain-English guide to common illnesses travellers and expats face in Vietnam — food poisoning, dehydration, fever, dengue awareness and more — why they happen, when to seek emergency help, and how to get a 24/7 doctor to your door. For emergencies call 115.',
    h1: 'Common Illnesses in Vietnam: A Traveller\u2019s Health Guide',
    intro: 'Most illnesses travellers experience in Vietnam are common and treatable. This guide explains why they happen, the warning signs that mean you should seek emergency help, and how to get a licensed English-speaking doctor to your hotel, apartment or Airbnb within 60 minutes, 24/7.',
  },
};